import Foto from "../../assets/images/nossos_convidados.png";

const NossosConvidados = () => {
  return (
    <section id="nossos-convidados">
      <div className="conteudo">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-6 d-flex flex-column justify-content-center">
              <div className="titulo">
                <h1>Nossos Convidados</h1>
              </div>

              <p>
                Prepare-se para conhecer as últimas novidades e os principais
                temas do mercado! Reunimos um time de palestrantes dedicados a
                capacitar cada participante a alcançar resultados excepcionais
                em suas jornadas profissionais.
              </p>
              <p>
                Contaremos com a presença de treinadores de alta performance
                compartilhando suas experiências e conhecimentos, além de
                proporcionar insights valiosos que vão aprimorar suas
                habilidades e estratégias.
              </p>

              <p style={{color: '#f89e32', marginTop: '4rem'}}>
                O Líderes do Sucesso é um evento único para impulsionar o seu
                crescimento e sucesso profissional.
              </p>
            </div>
            <div className="col-12 col-lg-6 d-flex align-items-center justify-content-center">
              <img
                src={Foto}
                width='80%'
                alt="Líderes do Sucesso Team Edition 2022"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NossosConvidados;
